module.exports = __webpack_public_path__ + "img/news3-2.feaf0381.png";